<section class="grid gap-4 pb-4">
  <div class="flex flex-wrap items-center justify-between gap-3">
    <div>
      <page-title [title]="'Employee management'"></page-title>
    </div>

    <div class="flex items-center gap-3">
      @if (canImport()) {
        <!-- <a mat-stroked-button routerLink="/employees/imports">Import</a> -->
        <button matButton="filled" type="button" (click)="utils.navigateTo('/employees/imports')">
          <mat-icon>file_upload</mat-icon>
          Import employees
        </button>
      }
      @if (canCreate()) {
        <!-- <a mat-flat-button routerLink="/employees/new">Create employee</a> -->
        <button matButton="filled" type="button" class="mom-danger" (click)="utils.navigateTo('/employees/new')">
          <mat-icon>person_add</mat-icon>
          Create employee
        </button>
      }
    </div>
  </div>

  <employee-table
    [employees]="employeeStore.employees()"
    [loading]="employeeStore.loading()"
    [searchTerm]="employeeStore.employeesSearch()"
    [pageNumber]="employeeStore.employeesPageNumber()"
    [pageSize]="employeeStore.employeesPageSize()"
    [totalCount]="employeeStore.employeesTotalCount()"
    [totalPages]="employeeStore.employeesTotalPages()"
    [canDeactivate]="canDeactivate()"
    [canActivate]="canActivate()"
    [canUpdate]="canUpdate()"
    [actionEmployeeId]="actionEmployeeId()"
    (refreshed)="refresh()"
    (searchChanged)="searchEmployees($event)"
    (pageChanged)="changePage($event)"
    (toggled)="toggleEmployeeActive($event)"
    (manageDependants)="openDependantsManagement($event)" />
</section>